import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ibanFormatter',
  standalone: true,
})
export class IbanFormatterPipe implements PipeTransform {
  /**
   * Formats an IBAN string into groups of 4 characters.
   * Example: DE1234567890 -> DE12 3456 7890
   */
  transform(value: string | undefined | null): string {
    if (!value) return '';

    const cleanValue = value.replace(/\s+/g, '').toUpperCase();

    const matches = cleanValue.match(/.{1,4}/g);

    return matches ? matches.join(' ') : cleanValue;
  }
}
